
const FirebaseService = {}


	
export default FirebaseService